"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _filter = _interopRequireDefault(require("lodash/filter"));
var _filterSelections = _interopRequireDefault(require("../../utils/filterSelections"));
/** @deprecated Please use the version found in the `library/` folder instead. Usage examples in README. */
var _default = exports["default"] = function _default(choices, options) {
  return (0, _filter["default"])(choices, function (choice) {
    return (0, _filterSelections["default"])(choice, options, choices);
  });
};
//# sourceMappingURL=getSelectedChoices.js.map